import React from 'react';
import { Link } from '@material-ui/core';

const HomeUserInfo = (props) => {
    const _courses = {
        pathname: "/courses",
        state: { path: "/courses", keywords: "",},
        prevLoc:'/home',
    };

    const _certs = {
        pathname: "/transcripts",
        state: { path: "/transcripts", keywords: "",},
        prevLoc:'/home',
    };

    const _dis = {
        pathname: "/profile",
        state: { tab: 1, path: "/profile", keywords: "",},
        prevLoc:'/home',
    }

    return (
        <div className="flex-col-between padding-left-16 padding-right-16">
            {props.name
                ? (<div className="aua-app-title">{props.name}</div>)
                : null
            }

            <div className="aua-home-info-box">
                <div className="aua-home-info aua-widget-3">
                    <div className="aua-home-info-text">This Week</div>
                    <div className="aua-home-info-icon">{props.reporting.weekly.rank}</div>
                    <div className="aua-home-info-text">{props.reporting.weekly.title}</div>
                </div>

                <div className="aua-home-info aua-widget-3">
                   
                    <div className="aua-home-info-text">This Month</div>
                    <div className="aua-home-info-icon">{props.reporting.monthly.rank}</div>
                    <div className="aua-home-info-text">{props.reporting.monthly.title}</div>
                </div>

                <div className="aua-home-info aua-widget-3">
                    <div className="aua-home-info-text">Total</div>
                    <div className="aua-home-info-icon">{props.reporting.total.rank}</div>
                    <div className="aua-home-info-text">{props.reporting.total.title}</div>
                </div>
            </div>
        </div>
    )
}

export { HomeUserInfo }